export const TYPE_LABEL = {
  details: "Details",
  logo: "Logo",
  rules: "Lead rules",
  page: "New page",
  lead_pages: "Shared pages",
  consent: "Consent text",
};

export const STATUS_OPTIONS = [
  ["pending", "Waiting"],
  ["approved", "Approved"],
  ["rejected", "Turned down"],
  ["superseded", "Replaced"],
  ["all", "All"],
];

export const STATUS_STYLE = {
  pending: "border-amber-800 bg-amber-100 text-amber-900",
  approved: "border-emerald-800 bg-emerald-100 text-emerald-900",
  rejected: "border-rose-800 bg-rose-100 text-rose-900",
  superseded: "border-zinc-700 bg-zinc-100 text-zinc-700",
};

export const statusLabel = (s) => (STATUS_OPTIONS.find(([v]) => v === s) || [s, s])[1];

// Existing approve / turn-down endpoints for each kind of request.
export const ENDPOINT = {
  detail: "/admin/buyer-detail-requests",
  criteria: "/admin/buyer-criteria-requests",
  page: "/admin/page-requests",
  profile: "/admin/buyer-profile-changes",
};

export const noteBody = (source, note) => (source === "criteria" ? { review_notes: note } : { note });

export const fmtWhen = (iso) => (iso ? new Date(iso).toLocaleString() : "—");
